// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"fb96771a","213":"b9a8d3f7","453":"3cab669f"}[chunkId] + ".chunk.js";
};